import { Action, createReducer, on } from '@ngrx/store';
import * as LoginAction from './login.actions';
import { User } from '../../../shared/user/user.model';
import { Association } from '../../../shared/association/association.model';
import { UserAccess } from '../../../shared/user/user-access.model';

export interface LoginState {
  loggedIn: boolean;
  error: boolean;
  load: boolean;
  loggedUser: User;
  userAccess: UserAccess;
  idToken: string;
  currentAssociation: string;
  userAssociations: Association[];
}

export const loginInitialState: LoginState = {
  loggedIn: false,
  loggedUser: undefined,
  userAccess: undefined,
  error: false,
  load: false,
  idToken: '',
  currentAssociation: undefined,
  userAssociations: [],
};

const reducer = createReducer(
  loginInitialState,
  on(LoginAction.login, state => ({
    ...state,
    load: true
  })),
  on(LoginAction.loginSuccess, (state, { token }) => ({
    ...state,
    loggedIn: true,
    load: true,
    idToken: token,
    error: false,
  })),
  on(LoginAction.loginFailure, state => ({
    ...state,
    loggedIn: false,
    load: false,
    error: true,
  })),
  on(LoginAction.loadUserAccess, state => ({
    ...state,
  })),
  on(LoginAction.loadUserAccessSuccess, (state, {}) => ({
    ...state,
  })),
  on(LoginAction.setLoggedUser, (state, { user }) => ({
    ...state,
    loggedUser: user,
    error: false,
  })),
  on(LoginAction.setUserAccess, (state, { access }) => ({
    ...state,
    userAccess: access,
    error: false,
  })),
  on(LoginAction.getUserAssociationsSuccess, (state, { associations }) => ({
    ...state,
    userAssociations: associations,
    error: false,
  })),
  on(LoginAction.loadUserAccessFailure,
    LoginAction.getUserAssociationsFailure, state => ({
      ...state,
      error: true,
    })),
  on(LoginAction.setCurrentAssociation, (state, { associationId }) => ({
    ...state,
    currentAssociation: associationId,
    error: false,
  })),
);

export function LoginReducer(state: LoginState | undefined, action: Action) {
  return reducer(state, action);
}

